import { QcsSelect } from '../basic/QcsSelect';
import { QcsMenuItem } from '../basic/QcsMenuItem';
import { useTranslation } from 'react-i18next';

// The select can only hold a string, the filter holds the real value
// (boolean, enum, ...). getOptionId bridges the two.
const NO_FILTER = '';

interface Props<T> {
  className?: string;
  value?: T;
  options: T[];
  onChange: (value?: T) => void;
  getOptionId: (option: T) => string;
  getOptionName: (option: T) => string;
}

export function GridFilterSelect<T>({ className, value, options, onChange, getOptionId, getOptionName }: Readonly<Props<T>>) {
  const { t } = useTranslation();

  const optionById = new Map(options.map((o) => [getOptionId(o), o]));
  const nonSelected = <em>{t('common.nonSelected')}</em>;

  return (
    <QcsSelect
      className={className}
      fullWidth={true}
      displayEmpty
      value={value === undefined ? NO_FILTER : getOptionId(value)}
      // NO_FILTER is not in the map, so the lookup gives undefined = no filter
      onChange={(event) => onChange(optionById.get(event.target.value))}
      renderValue={(id) => {
        const option = optionById.get(id);
        return option === undefined ? nonSelected : getOptionName(option);
      }}
    >
      <QcsMenuItem value={NO_FILTER}>{nonSelected}</QcsMenuItem>
      {options.map((option) => (
        <QcsMenuItem key={getOptionId(option)} value={getOptionId(option)}>
          {getOptionName(option)}
        </QcsMenuItem>
      ))}
    </QcsSelect>
  );
}
